class AsbestosEvent {

    constructor(options = {}) {
        this.config = {
            'debug' : false
        };
        for(const key in options) this.config[key] = options[key];
        if (this.config['debug']) {
            console.log(this.constructor.name + " Loaded!");
        }

    }

    getTracking(element, action = "Click", nonInteraction = false) {
        let data = {
            name : "Custom Event",
            props : {
                action: action || 'Click',
                location: element.closest('[data-location]').dataset.location || 'undefined',
                microIgnore: false,
                nonInteraction: nonInteraction
            }
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        data = this.getTracking(element);
        gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }

    getLocation(el) {
        const element = el.closest('[data-location]');
        return {
            element : element,
            name : element.dataset.location
        }
    }

    getPosition(el, selectorClass) {
        if (!el) return;

        const location = el.closest('[data-location]');
        const elements = location.querySelectorAll('.'+selectorClass);
        const index = Array.prototype.indexOf.call(elements, el);

        return index + 1;
    }

    getComponentModifiers(component, componentClass) {

        if(!component.className) return [];

        const classes = component.className.split(' ');
        const prefix = componentClass+'--';

        const modifiers = classes.filter(modClass => modClass.startsWith(prefix))
                                .map(modClass => modClass.replace(prefix, ''));

        return modifiers;
    }

    getComponentModifiersByDataAttribute(component) {
        if (!component){
            return [];
        }

        const modifiers = component.dataset.modifiers ? 
            component.dataset.modifiers.split(',').map(mod => mod.trim()) : 
            [];

        return modifiers;
    }

    getRelativePosition(el) {
        const type = el.dataset.type;
        const elements = document.querySelectorAll('[data-type="'+type+'"]');
        const index = Array.prototype.indexOf.call(elements, el);
        return index + 1;
    }

    getDataTrackingAttributes(el) {
        return Object.keys(el.dataset)
            .filter(key => key.startsWith('track'))
            .reduce((obj, key) => {
                obj[key.replace('track', '').toLowerCase()] = el.dataset[key];
                return obj;
            }, {});
    }

    getParentByClass(el, el_class) {
        if (el.classList && el.classList.contains(el_class)) {
            return el
        }
        const parent = el.parentNode;
        if (parent != undefined) {
            return this.getParentByClass(parent, el_class);
        } else {
            return false;
        }
    }

    getParentByDataAttribute(el, attribute) {
        if (el.dataset && el.dataset[attribute]) {
            return el
        }
        const parent = el.parentNode;
        if (parent != undefined) {
            return this.getParentByDataAttribute(parent, attribute);
        } else {
            return false;
        }
    }

    getSiblingIndex(element) {
        var index = 0;
        while (element.previousElementSibling) {
            index++;
            element = element.previousElementSibling;
        }
        return index;
    }


    getAsbestosOffer(element) {
        return element.dataset.offer ? element.dataset.offer : (element.getAttribute('href').includes("https://www.asbestos.com") ? element.getAttribute('href').replace("https://www.asbestos.com", '') : element.getAttribute('href') );
    }

    getGtagProps( data ) {

        var name = data.name,
            props = data.props,
            action = props.action,
            label = props.label;

        if ( name == 'CTA' ) {
            if( props.location == "simple-offer" ) {
                label = ["Location: " + props.location, "Offer: " + props.offer, "Modifiers: " + props.modifiers];
            } else {
                label = ["Location: " + props.location, "Position: " + props.position, "Offer: " + props.offer, "Modifiers: " + props.modifiers];
            }

        } else if ( name == 'Button' ) {
            label = ["Location: " + props.location, "Offer: " + props.offer, "Modifiers: " + props.modifiers];

        } else if ( name == 'Reading' ) {
            label = ["Depth: " + props.depth];

            if ( action == '20_Seconds' ) {
                label = null;
            }

        } else if ( name == 'Video' ) {
            label = ["Location: " + props.location, "Position: " + props.position, "Offer: " + props.offer];

            if ( action == 'Watch' ) {
                label.push(["Progress: " + props.progress]);
            }

        } else if ( name == 'Form' ) {
            label = ["Step: " + props.step, "Location: " + props.location, "Offer: " + props.offer];

            if( action == 'Input' ) {
                label.push(["Field Name: " + props.field_name, "Valid: " + props.valid]);

            } else if ( action == 'step') {
                label.push(["Step: " + props.label]);
            }

        } else if ( name == 'Chat' ) {
            if ( action == 'Click' ) {
                label = null;
            }

        } else if ( name == 'Navigation' ) {
            if ( action == 'Click' ) {
                label = ["Location: " + props.location, "Copy: " + props.copy, "Order: " + props.order, "Modifiers: " + props.modifiers];
            }
        }

        label = (Array.isArray(label)) ? label.join(' | ') : label;

        //set cookie for cta_id that will be passed into Salesforce upon form submission
        if (name == 'CTA') {
            setCookie('cta_id', label, 365, '/');
        }

        var gtag_props = {
            'event_category' : name,
            'event_label' : label,
            'non_interaction' : props.nonInteraction
        }

        return gtag_props;
    }
}

class SimpleOfferEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-simple";
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: 'simple-offer',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click', // This presumes that we are adding data-action="Close" to the simple offer close button
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            variant_name: element.dataset.variantName || 'undefined',
            variant_url: element.dataset.variantUrl || 'undefined',
            type : "Simple Offer", // In-line / Full-width / Factbox / Etc.
            buttonLink : element.getAttribute('href') || "undefined", // Historically just used Offer
            destination : element.dataset.destination || "undefined", // LP / Modal, did not want to overwrite Offer
            title : element.dataset.title || "undefined",
            description : element.dataset.description || "undefined",
            currentUrl : window.location.href || "undefined",
        };
        Object.assign(props, this.getDataTrackingAttributes(element));
        let data = {
            name : "CTA",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd><dt>Type:</dt><dd>' + data.props.type + '</dd><dt>Destination:</dt><dd>' + data.props.destination + '</dd><dt>Variant Name:</dt><dd>' + data.props.variant_name + '</dd><dt>Variant URL:</dt><dd>' + data.props.variant_url + '</dd></dl>';

        return tooltipContent;
    }
}

class SimpleOfferSidebarEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-cta";
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: 'simple-offer',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click', // This presumes that we are adding data-action="Close" to the simple offer close button
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            variant_name: element.dataset.variantName || 'undefined',
            variant_url: element.dataset.variantUrl || 'undefined',
            type : "Simple Offer", // In-line / Full-width / Factbox / Etc.
            buttonLink : element.getAttribute('href') || "undefined", // Historically just used Offer
            destination : element.dataset.destination || "undefined", // LP / Modal, did not want to overwrite Offer
            title : element.dataset.title || "undefined",
            description : element.dataset.description || "undefined",
            currentUrl : window.location.href || "undefined",
        };
        Object.assign(props, this.getDataTrackingAttributes(element));
        let data = {
            name : "CTA",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd><dt>Type:</dt><dd>' + data.props.type + '</dd><dt>Destination:</dt><dd>' + data.props.destination + '</dd><dt>Variant Name:</dt><dd>' + data.props.variant_name + '</dd><dt>Variant URL:</dt><dd>' + data.props.variant_url + '</dd></dl>';

        return tooltipContent;
    }
}

class VideoEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-video";
        this.dataVideo = "vid"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass) || this.getParentByDataAttribute(element, this.dataVideo);
        let props = {
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            position: this.getPosition(parent, this.cssClass) || 'undefined',
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            type : element.dataset.type || "undefined", // Carousel / Stand Alone / Etc.
            currentUrl : window.location.href || "undefined",
            // No way to currently determine length of play time without resending new events periodically as a user watches a video.
        };
        Object.assign(props, this.getDataTrackingAttributes(element));
        let data = {
            name : "Video",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd><dt>Type:</dt><dd>' + data.props.type + '</dd></dl>';
        return tooltipContent;
    }
}

class CTAEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-cta"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        // Maybe some code to extrapolate title/description?
        let props = {
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            position: this.getPosition(parent, this.cssClass) || 'undefined',
            relativePosition: this.getRelativePosition(element) || 'undefined',
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            variant_name: element.dataset.variantName || 'undefined',
            variant_url: element.dataset.variantUrl || 'undefined',
            type : element.dataset.type || "undefined", // In-line / Full-width / Factbox / Etc.
            buttonLink : element.getAttribute('href') || "undefined", // Historically just used Offer
            destination : element.dataset.destination || "undefined", // LP / Modal, did not want to overwrite Offer
            title : element.dataset.title || "undefined",
            description : element.dataset.description || "undefined",
            currentUrl : window.location.href || "undefined",

        };
        Object.assign(props, this.getDataTrackingAttributes(element));

        let data = {
            name : "CTA",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd><dt>Type:</dt><dd>' + data.props.type + '</dd><dt>Destination:</dt><dd>' + data.props.destination + '</dd><dt>Variant Name:</dt><dd>' + data.props.variant_name + '</dd><dt>Variant URL:</dt><dd>' + data.props.variant_url + '</dd></dl>';

        return tooltipContent;
    }
}

class JumpToEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-jump-to"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            copy : element.textContent.trim(),
            order : this.getSiblingIndex(element.parentNode) + 1,
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Navigation",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }
}

class FeaturedStickyEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "featured-sticky";
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            copy : element.textContent.trim(),
            order : this.getSiblingIndex(element.parentNode) + 1,
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: element.dataset.offer || element.getAttribute('href'),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Navigation",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }
}

class ButtonEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c-button"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        let props = {
            modifiers: this.getComponentModifiers(element, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Button",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }
    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }
}

class BackToTopEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "js-backToTop"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        let props = {
            modifiers: this.getComponentModifiers(element, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action,
            microIgnore: false,
            nonInteraction: nonInteraction,
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Button",
            props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + 'BackToTop'+ '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + ["Location: " + data.props.location, " Offer: " + data.props.offer, " Modifiers: " + data.props.modifiers] + '</dd></dl>';
        return tooltipContent;
    }
}

class RelatedPagesEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "c__link--related-pages"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            copy : element.textContent.trim(),
            order : this.getSiblingIndex(element.parentNode) + 1,
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: element.dataset.offer || element.getAttribute('href'),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Navigation",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + 'Navigation'+ '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + ["Location: " + data.props.location, " Offer: " + data.props.offer, " Modifiers: " + data.props.modifiers] + '</dd></dl>';
        return tooltipContent;
    }
}

class NavigationEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "nav-link"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            copy : element.textContent.trim(),
            order : this.getSiblingIndex(element.parentNode) + 1,
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: element.dataset.offer || element.getAttribute('href'),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Navigation",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + 'Navigation'+ '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + ["Location: " + data.props.location, " Offer: " + data.props.offer, " Modifiers: " + data.props.modifiers] + '</dd></dl>';
        return tooltipContent;
    }
}

class NavSectionEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.cssClass = "nav-section"
    }

    getTracking(element, action = "Open", nonInteraction = false) {
        const parent = this.getParentByClass(element, this.cssClass);
        let props = {
            copy : element.textContent.trim(),
            order : this.getSiblingIndex(element.parentNode) + 1,
            modifiers: this.getComponentModifiers(parent, this.cssClass).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: element.dataset.offer || element.getAttribute('href'),
            buttonCopy: element.querySelector('.c-link__parent a').textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Open',
            microIgnore: false,
            nonInteraction: nonInteraction,
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Navigation",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + 'Navigation'+ '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + ["Location: " + data.props.location, " Offer: " + data.props.offer, " Modifiers: " + data.props.modifiers] + '</dd></dl>';
        return tooltipContent;
    }
}

class TwCTAEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options)
        this.dataComponent = "twcta";
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        const parent = this.getParentByDataAttribute(element, this.dataComponent);

        // Maybe some code to extrapolate title/description?
        let props = {
            modifiers: this.getComponentModifiersByDataAttribute(parent).join(", "),
            position: this.getPosition(parent, this.dataComponent) || 'undefined',
            relativePosition: this.getRelativePosition(element) || 'undefined',
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            variant_name: element.dataset.variantName || 'undefined',
            variant_url: element.dataset.variantUrl || 'undefined',
            type : element.dataset.type || "undefined", // In-line / Full-width / Factbox / Etc.
            buttonLink : element.getAttribute('href') || "undefined", // Historically just used Offer
            destination : element.dataset.destination || "undefined", // LP / Modal, did not want to overwrite Offer
            title : element.dataset.title || "undefined",
            description : element.dataset.description || "undefined",
            currentUrl : window.location.href || "undefined",

        };
        Object.assign(props, this.getDataTrackingAttributes(element));

        let data = {
            name : "CTA",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }

    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        let tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd><dt>Type:</dt><dd>' + data.props.type + '</dd><dt>Destination:</dt><dd>' + data.props.destination + '</dd><dt>Variant Name:</dt><dd>' + data.props.variant_name + '</dd><dt>Variant URL:</dt><dd>' + data.props.variant_url + '</dd></dl>';

        return tooltipContent;
    }
}

class TwButtonEvent extends AsbestosEvent {
    constructor(options = {}) {
        super(options);
        this.dataComponent = "twbutton"
    }

    getTracking(element, action = "Click", nonInteraction = false) {
        let props = {
            modifiers: this.getComponentModifiers(element, this.dataComponent).join(", "),
            location: element.closest('[data-location]').dataset.location || 'undefined',
            offer: this.getAsbestosOffer(element),
            buttonCopy: element.textContent.replace(/[^a-zA-Z 0-9]+/g, "").trim(),
            action: action || 'Click',
            microIgnore: false,
            nonInteraction: nonInteraction,
            // New Fields
            currentUrl : window.location.href || "undefined",
        };
        let data = {
            name : "Button",
            props : props
        };
        if (this.config['debug']) {
            console.log(data);
        }
        return data;
    }
    getTooltip(element) {
        let data = this.getTracking(element);
        let gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }
}